import { ApolloError, ServerError } from '@apollo/client';
import { BraintreeError } from 'braintree-web';
import { path } from 'ramda';

export type GenericError = Error &
  Partial<Omit<ApolloError, keyof Error>> & {
    displayMessage?: string;
    reason?: string;
  };

export const isGenericError = (error: unknown): error is GenericError =>
  typeof (error as GenericError)?.message === 'string';

type NetworkError = {
  title?: string;
  detail?: string | { message?: string }[];
};

const isBraintreeError = (error: unknown): error is BraintreeError =>
  error != null && typeof error === 'object' && 'name' in error && error.name === 'BraintreeError';

const getBraintreeErrorMessage = (error: BraintreeError): string | undefined => {
  if (error.code === 'THREEDS_LOOKUP_VALIDATION_ERROR')
    return path(
      ['details', 'originalError', 'details', 'originalError', 'error', 'message'],
      error
    );
};

export const getNetworkErrors = (error: GenericError) =>
  ((error.networkError as ServerError)?.result as Record<string, NetworkError[] | undefined | null>)
    ?.errors;

export const getNetworkErrorMessage = (error: GenericError) => {
  if (isBraintreeError(error)) return getBraintreeErrorMessage(error);
  const networkErrors = getNetworkErrors(error);
  const details = networkErrors?.[0]?.detail;
  return Array.isArray(details) ? details[0]?.message : details;
};
